(() => {
  const refineSubscription = widget => {
    if (!widget.previousElementSibling?.classList.contains('quick-frequency-heading')) {
      const heading = document.createElement('div');
      heading.className = 'quick-option-label quick-frequency-heading';
      heading.textContent = '03 • Escolha a frequência';
      widget.before(heading);
    }
    widget.querySelectorAll('.appstle_single_option_text').forEach(label => {
      if (/^Receba Mensalmente$/i.test(label.textContent.trim())) label.textContent = 'Entrega mensal';
    });
    widget.querySelectorAll('.appstle_subscription_radio_wrapper').forEach(row => {
      const badge = row.querySelector('.appstle-save-badge');
      const prices = row.querySelector('.appstle_subscription_amount_wrapper');
      if (badge && prices && badge.parentElement !== prices) prices.appendChild(badge);
    });
    if (!widget.querySelector('.quick-subscription-benefits')) {
      const benefits = document.createElement('div');
      benefits.className = 'quick-subscription-benefits';
      benefits.innerHTML = '<span><b aria-hidden="true">✓</b>Frete grátis para o estado de São Paulo</span><span><b aria-hidden="true">✓</b>Cancele quando quiser</span>';
      const about = widget.querySelector('.quick-subscription-about');
      if (about) about.before(benefits); else widget.appendChild(benefits);
    }
    if (widget.querySelector('.quick-subscription-about')) return;
    let dialog = document.getElementById('quick-subscription-dialog');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'quick-subscription-dialog';
      dialog.className = 'quick-subscription-dialog';
      dialog.setAttribute('aria-labelledby', 'quick-subscription-title');
      dialog.innerHTML = '<div class="quick-dialog-header"><h2 id="quick-subscription-title">Sobre a assinatura</h2><button type="button" aria-label="Fechar">×</button></div><p>Escolha a assinatura para receber seus Quick Sticks regularmente com o desconto indicado no plano.</p><p class="quick-dialog-frequency"></p><p>Você pode cancelar sua assinatura a qualquer momento.</p>';
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      document.body.appendChild(dialog);
    }
    const about = document.createElement('button');
    about.type = 'button';
    about.className = 'quick-subscription-about';
    about.innerHTML = '<span aria-hidden="true">i</span> Sobre a assinatura';
    about.addEventListener('click', () => {
      const frequency = widget.querySelector('.appstle_single_option_text')?.textContent.trim()
        || widget.querySelector('.appstle_select option:checked')?.textContent.trim();
      dialog.querySelector('.quick-dialog-frequency').textContent = frequency ? 'Frequência: ' + frequency.toLocaleLowerCase('pt-BR') + '.' : '';
      dialog.showModal();
    });
    widget.appendChild(about);
  };
  const syncSubscription = () => {
    const widget = document.querySelector('.appstle_subscription_wrapper');
    if (widget) refineSubscription(widget);
    document.querySelectorAll('.appstle_one_time_text').forEach(label => {
      if (label.textContent !== 'Compra única') label.textContent = 'Compra única';
    });
    document.querySelectorAll('.appstle_subscribe_save_text').forEach(label => {
      if (label.textContent !== 'Assine e economize') label.textContent = 'Assine e economize';
    });
    document.querySelectorAll('.appstle-save-badge').forEach(label => {
      const revised = label.textContent.trim().replace(/\s*(?:de desconto|off)$/i, ' OFF');
      if (label.textContent !== revised) label.textContent = revised;
    });
    const selected = document.querySelector('.appstle_subscription_wrapper input[name="selling_plan"]:checked');
    if (!selected) return;
    document.querySelectorAll('product-form form[action*="cart/add"]').forEach(form => {
      let field = form.querySelector('input[type="hidden"][name="selling_plan"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'selling_plan';
        form.appendChild(field);
      }
      field.value = selected.value;
    });
    const amount = selected.closest('.appstle_subscription_radio_wrapper,.appstle_one_time_details_wrapper')?.querySelector('.appstle_subscription_amount')?.textContent.trim();
    if (amount) {
      document.querySelectorAll('[id^="main-atc-price-"],[id^="sticky-atc-price-"]').forEach(price => { price.textContent = amount + ' •'; });
      document.querySelectorAll('.quick-price strong,.sticky-atc__price .price-item--regular').forEach(price => { price.textContent = amount; });
      const summary = document.querySelector('.quick-price');
      const count = Number(summary?.dataset.packCount);
      const cents = Number(amount.replace(/[^0-9]/g, ''));
      if (count && cents) {
        const perStick = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Math.round(cents / count) / 100);
        summary.querySelector('span').textContent = perStick + ' por unidade';
      }
    }
  };
  document.addEventListener('change', event => {
    if (event.target.matches('.appstle_subscription_wrapper input[name="selling_plan"]')) {
      syncSubscription();
      requestAnimationFrame(syncSubscription);
    }
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('product-form form[action*="cart/add"]')) syncSubscription();
  }, true);
  const subscriptionObserver = new MutationObserver(() => {
    const widget = document.querySelector('.appstle_subscription_wrapper');
    if (widget) {
      subscriptionObserver.disconnect();
      syncSubscription();
      const widgetObserver = new MutationObserver(() => {
        widgetObserver.disconnect();
        syncSubscription();
        widgetObserver.observe(widget, { childList: true, subtree: true, characterData: true });
      });
      widgetObserver.observe(widget, { childList: true, subtree: true, characterData: true });
    }
  });
  subscriptionObserver.observe(document.documentElement, { childList: true, subtree: true });
  syncSubscription();
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.quick-recommend-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    const error = form.querySelector('.quick-recommend-error');
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    error.textContent = '';
    const drawer = document.querySelector('cart-drawer');
    const body = new FormData(form);
    const sections = drawer?.getSectionsToRender?.();
    if (sections) body.append('sections', sections.map(section => section.id).join(','));
    body.append('sections_url', window.location.pathname);
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message);
      if (drawer?.renderContents && data.sections) {
        drawer.renderContents(data);
      } else {
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      }
    } catch (failure) {
      error.textContent = failure.message || window.quickStrings?.cartError || '';
    } finally {
      button.disabled = false;
      form.removeAttribute('aria-busy');
    }
  });
})();

